module.exports = __webpack_public_path__ + "img/1首页产品图—厨具.64d489ea.png";